<template>
  <div id="app" style="position:relative;" :class="{appMobile: isMobile}">
     <div class="title-wraphead" style="display:none;">
        <div class="kctitleback">
        <!--<a href="https://ys.cnais.org.cn" target="_blank" style="text-decoration:none;">
          <img class="imgback" alt="title" src="@/assets/images/back.png">
          返回首页
        </a>-->

       </div>
       <div class="kctitlefont">
            开放包容成熟度数字孪生仪表盘
       </div>
     </div>
    <div class="wrap">
      <!-- 左 -->
      <!--<div class="left" ref="ref_leftDiv"></div>-->

      <!-- 中 -->
      <div class="center" ref="ref_centerDiv">
        <!--<div class="item-wrap" >
          <graph1 ref="ref21" :kcmapdata1="kcmapdata1" :kcmapdata2="kcmapdata2"/>
        </div>-->

        <div class="item-wrap">
          <div class="item-title">
            <div class="item-title_name" style="margin: 0 auto;">
              <img class="title_icon" src="@/assets/images/xingbie.png" />
              <!--<div class="title_name">全球主要国家OSRI趋势</div>-->
              <div class="title_name">Dynamics of OSRI for USA, UK, Germany, Japan, EU27, China, India, Russia and STLCs</div>
            </div>
            <!--<div class="largen_icon" @click="largenItem(0)"></div>-->
          </div>
          <div class="child1-wrap">
            <div class="pie1-wrap" style="height:300px;width:100%;">
              <stackChart1 ref="ref11" :sexdata="sexdata" v-on:chgYear="stackChart1_chgYear" style="width:100%;height:100%;" />
            </div>
          </div>
        </div>

        <div class="item-wrap">
          <div class="item-title">
            <div class="item-title_name" style="margin:0 auto">
              <img class="title_icon" src="@/assets/images/fenbu.png" />
              <!--<div class="title_name">全球OSRI排名前列国家和地区</div>-->
              <div class="title_name">Dimensions indicator data of current  ORSI in some countries and regions</div>
            </div>
            <!--<div class="largen_icon" @click="largenItem(6)"></div>-->
          </div>
          <div style="display:flex">
            <!--<pieChart4 ref="ref2" :casdepart="casdepart" style="width:50%;height:calc((100vh - 220px) * 8 / 25)" />-->
            <pieChart2 ref="ref2" :caedepart="casdepart2" style="width:25%;height:200px;" />
            <pieChart1 ref="ref1" :casdepart="casdepart1" style="width:25%;height:200px;" />
            <pieChart3 ref="ref3" :casdepart="casdepart3" style="width:25%;height:200px;" />
            <pieChart4 ref="ref4" :caedepart="casdepart4" style="width:25%;height:200px;" />
          </div>
        </div>

        <div class="item-wrap">
          <div class="item-title">
            <div class="item-title_name" style="margin:0 auto">
              <img class="title_icon" src="@/assets/images/gongzuoshichang.png" />
              <div class="title_name">The roadmap of China's open science and current status</div>
            </div>
            <!--<div class="largen_icon" @click="largenItem(4)"></div>-->
          </div>

          <div style="display:flex">
            <!--<table1 ref="ref23" :simpleavadata="simpleavadata" style="height:calc((100vh - 290px) * 10 / 25)" />-->
            <table1 ref="ref23" :simpleavadata="simpleavadata" v-on:chgHeight="table1_chgHeight" style="height:411px;"/>
          </div>
        </div>


      </div>

      <!-- 右 -->
      <!--<div class="right" ref="ref_rightDiv"></div>-->
    </div>

  </div>
</template>

<script>
import stackChart1 from '@/components/stackChart1.vue'
import stackChart2 from '@/components/stackChart2.vue'

import pieChart1 from '@/components/pieChart1.vue'
import pieChart2 from '@/components/pieChart2.vue'
import pieChart3 from '@/components/pieChart3.vue'
import pieChart4 from '@/components/pieChart4.vue'

import graph1 from '@/components/graph1.vue'
import funnelChart1 from '@/components/funnelChart1.vue'
import table1 from '@/components/table1.vue'

import { _debounce } from '@/assets/utils/common'
export default {
  name: 'App',
  components: {
    stackChart1,
    stackChart2,
    pieChart1,
    pieChart2,
    pieChart3,
    pieChart4,
    graph1,
    funnelChart1,
    table1,
  },
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 8) {
        return value.slice(0, 8) + '...'
      }
      return value
    },
    formatyigu(value) {
      if (!value) return ''
      if (value.length > 3) {
        return value.replace('（已故）', '')
      }
      return value
    }
  },
  data() {
    return {
      ysinfosimple: [
        {
          id: '',
          casID: '',
          name: '院士1',
          work: '工作单位1',
          city: '城市1',
          type: ''
        }
      ],
      ysinfofull: [
        {
          id: '',
          casID: '',
          name: '院士1',
          work: '工作单位1',
          city: '城市1',
          type: ''
        }
      ],
      sexdata: [],
      agedata: {
        age: [],
        casyear: []
      },
      casyeardata: [],
      careerdata: [],
      cascae: [],
      casdepart: [],
      caedepart: [],
      treemapdata: [],
      simpletreemapdata: [],
      simpleavadata: { name: [], data: [] },
      avadata: { name: [], data: [] },
      kcmapdata1: [],
      kcmapdata2: [],
      total: 0,
      changzhu: 0,
      birth: 0,
      liuru: 0,
      liuchu: 0,
      avayear: 0,
      selectcity: '全部',
      maskState: false,
      largenStates: [false, false, false, false, false, false, false],
      isFullScreen: true,



      isMobile: true,
      ifInIframe: false,        // 当前页面是否在iframe中

      pieYear : 1996,
      casdepart1 : [],
      casdepart2 : [],
      casdepart3 : [],
      casdepart4 : [],

      // 饼图1: 美国
      casdepart1_all : {
            // [ OA占比, OD占比, OP占比 ]
        1996: [ 0.137, 0.385, 1 ],
        1997: [ 0.142, 0.4  , 1 ],
        1998: [ 0.15 , 0.4  , 1 ],
        1999: [ 0.152, 0.404, 1 ],
        2000: [ 0.161, 0.385, 1 ],
        2001: [ 0.158, 0.379, 1 ],
        2002: [ 0.172, 0.415, 1 ],
        2003: [ 0.209, 0.449, 1 ],
        2004: [ 0.221, 0.484, 1 ],
        2005: [ 0.24 , 0.534, 1 ],
        2006: [ 0.253, 0.55 , 1 ],
        2007: [ 0.271, 0.621, 1 ],
        2008: [ 0.279, 0.599, 1 ],
        2009: [ 0.291, 0.659, 1 ],       // 和不是100
        2010: [ 0.306, 0.681, 1 ],
        2011: [ 0.325, 0.708, 1 ],
        2012: [ 0.349, 0.738, 1 ],
        2013: [ 0.373, 0.765, 1 ],
        2014: [ 0.396, 0.902, 1 ],
        2015: [ 0.42 , 0.915, 1 ],
        2016: [ 0.446, 0.912, 1 ],
        2017: [ 0.468, 0.934, 1 ],
        2018: [ 0.496, 0.941, 1 ],
        2019: [ 0.519, 0.939, 1 ],
        2020: [ 0.56 , 0.941, 1 ],
        2021: [ 0.601, 1    , 1 ],
        2022: [ 0.602, 0.959, 1 ],
        2023: [ 0.633, 0.999, 1 ],
      },

      // 饼图2: 欧盟
      casdepart2_all : {
        1996: [ 0.186, 0.276, 0.889 ],
        1997: [ 0.198, 0.289, 0.889 ],
        1998: [ 0.206, 0.296, 0.889 ],
        1999: [ 0.211, 0.299, 0.889 ],
        2000: [ 0.22 , 0.314, 0.889 ],
        2001: [ 0.216, 0.328, 0.889 ],
        2002: [ 0.234, 0.343, 0.889 ],
        2003: [ 0.28 , 0.373, 0.889 ],
        2004: [ 0.295, 0.4  , 0.889 ],
        2005: [ 0.317, 0.455, 0.889 ],
        2006: [ 0.33 , 0.483, 0.889 ],
        2007: [ 0.352, 0.513, 0.889 ],
        2008: [ 0.366, 0.543, 0.889 ],
        2009: [ 0.388, 0.573, 0.889 ],
        2010: [ 0.405, 0.602, 0.889 ],
        2011: [ 0.431, 0.638, 0.889 ],
        2012: [ 0.461, 0.679, 0.889 ],
        2013: [ 0.491, 0.71 , 0.889 ],
        2014: [ 0.52 , 0.747, 0.889 ],
        2015: [ 0.551, 0.762, 0.889 ],
        2016: [ 0.586, 0.787, 0.889 ],
        2017: [ 0.62 , 0.806, 0.889 ],
        2018: [ 0.661, 0.833, 0.889 ],
        2019: [ 0.706, 0.845, 0.889 ],
        2020: [ 0.807, 0.899, 0.889 ],
        2021: [ 0.917, 0.99 , 0.889 ],
        2022: [ 0.955, 0.987, 0.889 ],
        2023: [ 1    , 0.987, 0.889 ],
      },

      // 饼图3: 中国
      casdepart3_all : {
            // [ OA占比, OD占比, OP占比 ]
        1996: [ 0.073, 0.025, 0.556 ],
        1997: [ 0.078, 0.027, 0.556 ],
        1998: [ 0.075, 0.032, 0.556 ],
        1999: [ 0.076, 0.033, 0.556 ],
        2000: [ 0.081, 0.039, 0.556 ],
        2001: [ 0.07 , 0.051, 0.556 ],
        2002: [ 0.084, 0.049, 0.556 ],
        2003: [ 0.1  , 0.067, 0.556 ],
        2004: [ 0.095, 0.092, 0.556 ],
        2005: [ 0.089, 0.13 , 0.556 ],
        2006: [ 0.095, 0.132, 0.556 ],
        2007: [ 0.101, 0.126, 0.556 ],
        2008: [ 0.109, 0.162, 0.556 ],
        2009: [ 0.117, 0.166, 0.556 ],
        2010: [ 0.126, 0.182, 0.556 ],
        2011: [ 0.138, 0.214, 0.556 ],
        2012: [ 0.154, 0.313, 0.556 ],
        2013: [ 0.18 , 0.286, 0.556 ],
        2014: [ 0.202, 0.314, 0.556 ],
        2015: [ 0.237, 0.34 , 0.556 ],
        2016: [ 0.261, 0.394, 0.556 ],
        2017: [ 0.3  , 0.399, 0.556 ],
        2018: [ 0.336, 0.465, 0.556 ],
        2019: [ 0.382, 0.524, 0.556 ],
        2020: [ 0.437, 0.623, 0.556 ],
        2021: [ 0.487, 0.692, 0.556 ],
        2022: [ 0.579, 0.824, 0.556 ],
        2023: [ 0.578, 0.844, 0.556 ],
      },

      // 饼图4: 德国
      casdepart4_all : {
            // [ OA占比, OD占比, OP占比 ]
        1996: [ 0.148, 0.06 , 1 ],
        1997: [ 0.153, 0.069, 1 ],
        1998: [ 0.159, 0.089, 1 ],
        1999: [ 0.166, 0.075, 1 ],
        2000: [ 0.169, 0.073, 1 ],
        2001: [ 0.168, 0.082, 1 ],
        2002: [ 0.181, 0.083, 1 ],
        2003: [ 0.211, 0.09 , 1 ],
        2004: [ 0.219, 0.1  , 1 ],
        2005: [ 0.225, 0.132, 1 ],
        2006: [ 0.23 , 0.137, 1 ],
        2007: [ 0.242, 0.145, 1 ],
        2008: [ 0.244, 0.15 , 1 ],
        2009: [ 0.257, 0.16 , 1 ],
        2010: [ 0.266, 0.169, 1 ],
        2011: [ 0.276, 0.18 , 1 ],
        2012: [ 0.285, 0.194, 1 ],
        2013: [ 0.297, 0.206, 1 ],
        2014: [ 0.308, 0.208, 1 ],
        2015: [ 0.322, 0.22 , 1 ],
        2016: [ 0.333, 0.236, 1],
        2017: [ 0.344, 0.253, 1 ],
        2018: [ 0.361, 0.271, 1],
        2019: [ 0.376, 0.297, 1 ],
        2020: [ 0.427, 0.355, 1 ],
        2021: [ 0.471, 0.424, 1 ],
        2022: [ 0.47 , 0.457, 1 ],
        2023: [ 0.47 , 0.507, 1 ],
      },

      pieYear2 : 1996,

    }
  },
  created() {
    /*this.getArticleDetail('all')
    this.getSexAndAge('all')
    this.getKcAva()*/

    // 20240909, 4个饼图, 当前的值各乘以一个系数：OP*0.2，OA*0.4,  OD*0.4。 且显示成小数, 不显示百分号
    for(var k in this.casdepart1_all){
        // [ OA占比, OD占比, OP占比 ]
        this.casdepart1_all[k][0] = this.NumbertoFixed2(this.casdepart1_all[k][0]*0.4);
        this.casdepart1_all[k][1] = this.NumbertoFixed2(this.casdepart1_all[k][1]*0.4);
        this.casdepart1_all[k][2] = this.NumbertoFixed2(this.casdepart1_all[k][2]*0.2);
    }
    for(var k in this.casdepart2_all){
        // [ OA占比, OD占比, OP占比 ]
        this.casdepart2_all[k][0] = this.NumbertoFixed2(this.casdepart2_all[k][0]*0.4);
        this.casdepart2_all[k][1] = this.NumbertoFixed2(this.casdepart2_all[k][1]*0.4);
        this.casdepart2_all[k][2] = this.NumbertoFixed2(this.casdepart2_all[k][2]*0.2);
    }
    for(var k in this.casdepart2_all){
        // [ OA占比, OD占比, OP占比 ]
        this.casdepart3_all[k][0] = this.NumbertoFixed2(this.casdepart3_all[k][0]*0.4);
        this.casdepart3_all[k][1] = this.NumbertoFixed2(this.casdepart3_all[k][1]*0.4);
        this.casdepart3_all[k][2] = this.NumbertoFixed2(this.casdepart3_all[k][2]*0.2);
    }
    for(var k in this.casdepart4_all){
        // [ OA占比, OD占比, OP占比 ]
        this.casdepart4_all[k][0] = this.NumbertoFixed2(this.casdepart4_all[k][0]*0.4);
        this.casdepart4_all[k][1] = this.NumbertoFixed2(this.casdepart4_all[k][1]*0.4);
        this.casdepart4_all[k][2] = this.NumbertoFixed2(this.casdepart4_all[k][2]*0.2);
    }

    this.casdepart = [
        {name: "生命科学和医学学部", value: 303},
        {name: "技术科学部", value: 263},
        {name: "数学物理学部", value: 254},
        {name: "地学部", value: 249},
        {name: "化学部", value: 222},
        {name: "信息技术科学部", value: 124},
        {name: "外籍院士（中科院）", value: 45}
    ];
    this.caedepart = this.casdepart;


    this.stackChart1_chgYear(2023);

  },
  mounted() {
    this.setRem()
    const resizeFn = _debounce(this.resetView, 300)
    window.addEventListener('resize', resizeFn)

    // 如果有父页面
    if(location.href != top.location.href){
        this.ifInIframe = true;
        const resizeFn2 = _debounce(this.updIframeSize, 300)
        top.window.addEventListener('resize', resizeFn2);
        this.updIframeSize();       // 立即执行一次
    }
  },
  methods: {
    NumbertoFixed2(val){
        return Math.round(val * 100) / 100;
    },
    allcity() {
      this.getArticleDetail('all')
      this.getSexAndAge('all')
      this.selectcity = '全部'
      // this.$refs['ref4'].getDataView()
      //this.$refs['ref4'].getMapCharts()
    },
    getArticleDetail(city) {
      this.axios.get('api/kcapi/get_ysinfo', {
        // 参数列表
        params: { city: city }// ,
        // 请求头配置
        // headers: { token: token }
      }).then((response) => {
        // console.log(response.data)
        this.ysinfosimple = response.data.ysinfosimple.slice(0, 5)
        this.ysinfofull = response.data.ysinfofull
      }).catch((response) => {
        console.log(response)
      })
    },
    getKcAva() {
      this.axios.get('api/kcapi/get_kcallinfo').then((response) => {
        this.treemapdata = response.data.etv
        this.simpletreemapdata = response.data.simpleetv
        this.avadata.name = response.data.kccity
        this.avadata.value = response.data.kcava
        const namear = []
        const valuear = []
        for (let i = 0; i < 15; i++) {
          namear.push(this.avadata.name[i])
          valuear.push(this.avadata.value[i])
        }
        this.simpleavadata.name = namear
        this.simpleavadata.value = valuear
        // this.simpleavadata.name = this.avadata.name.splice(6)
        // this.simpleavadata.value = this.avadata.value.splice(6)
        this.kcmapdata1 = response.data.kcmapdata1
        this.kcmapdata2 = response.data.kcmapdata2
      }).catch((response) => {
        console.log(response)
      })
    },
    getSexAndAge(city) {
      this.axios.get('api/kcapi/get_sexandage', {
        // 参数列表
        params: { city: city }// ,
        // 请求头配置
        // headers: { token: token }
      }).then((response) => {
        // console.log(response.data.age)
        this.sexdata = response.data.newsex

        this.agedata = response.data.echartage
        this.careerdata = response.data.career
        this.cascae = response.data.cascae
        this.casdepart = response.data.casdepart
        this.caedepart = response.data.caedepart
        this.total = response.data.total
        this.changzhu = response.data.changzhu
        this.birth = response.data.birth
        this.liuru = response.data.liuru
        this.liuchu = response.data.liuchu
        this.avayear = response.data.avayear
        if (city != 'all') { this.selectcity = city }
      }).catch((response) => {
        console.log(response)
      })
    },
    kcsearch(optype) {
      window.open('https://ys.cnais.org.cn/cas/searchDoc/kc?city=' + this.selectcity + '&field=' + optype, '_blank')
    },
    resetView() {
      this.setRem()
      this.reRender()
    },
    setRem() {
      const dEl = document.documentElement
      const ft = dEl.clientWidth
      if (ft > 1346) {
        dEl.style.fontSize = (ft / 60) + 'px'
      } else {
        dEl.style.fontSize = 20 + 'px'
      }


      /*
      // 设置3列的宽度
      let minW = ft>1346?ft:1346;
      //let centerW = ft>1900?950:676;
      let centerW = ft>1600?950:676;
      let w = Math.floor((minW - centerW )/2);
      //console.log(this.$refs['ref_leftDiv']);
      //if( !!this.$refs['ref_leftDiv'].style ){
      if( this.$refs['ref_leftDiv'] && this.$refs['ref_leftDiv'].style ){
          this.$refs['ref_centerDiv'].style.width = centerW+'px';
          this.$refs['ref_leftDiv'].style.width = w+'px';
          this.$refs['ref_rightDiv'].style.width = w+'px';
      }
      */

    },

    // 重新渲染
    reRender() {
      for (let i = 1; i <= 40; i++) {
        this.$nextTick(() => {
            //console.log(i, this.$refs['ref' + i]);
            this.$refs['ref' + i] && this.$refs['ref' + i].resize != undefined && this.$refs['ref' + i].resize()
        })
      }
    },

    // 设置父页面中iframe的高宽
    updIframeSize(){
        if(!this.ifInIframe){ return; }

        // iframe 设置的高宽都是 100%, 所以只设置 main
        let domMain = top.document.getElementById('main');

        // 防止报错
        if(!domMain){ return;}

        domMain.style.padding = 0;
        domMain.style.margin = '0';
        //domMain.style.border = '1px solid red';
        domMain.style.width = '100%';


        // 根据父页面宽度, 判断是否用mobile的样式
            // 根据适配, 设置高度。滚动条宽度17
        if(top.document.body.offsetWidth<992-17){
            this.isMobile = true;

            // 表格点击后, 高度会变
            let minHeight = 2493;           // 2493+20
            domMain.style.height = (Math.max(minHeight, document.body.offsetHeight)+20) + 'px';
        }else{
            this.isMobile = false;

            // 表格点击后, 高度会变
            //let minHeight = 968;           // 968+20
            let minHeight = 928;           // 968+20
            domMain.style.height = (Math.max(minHeight, document.body.offsetHeight)+20) + 'px';         // 20是横向滚动条的高度
        }
    },

    // 表格内, 格子显示/隐藏, 需要调整iframe的高度
    table1_chgHeight(){
        if(!this.ifInIframe){ return; }
        this.updIframeSize();
    },


    largenItem(i) {
      console.log('打开窗口那个')
      this.isFullScreen = false
      this.largenStates = new Array(7).fill(false)
      this.$set(this.largenStates, i, false)
      this.$nextTick(() => {
        this.$set(this.largenStates, i, true)
        if (i == 3) {
          //this.$refs.ref4.getMapCharts()
          console.log('打开窗口那个')
        }
      })
      this.maskState = true
    },
    // 全屏切换
    switchFull() {
      this.isFullScreen = !this.isFullScreen
      for (const i in this.largenStates) {
        if (this.largenStates[i]) {
          this.$set(this.largenStates, i, false)
          this.$nextTick(() => {
            this.$set(this.largenStates, i, true)
          })
          return
        }
      }
    },


    // 左上图, 点击年份后, 左下4个饼图切换到对应年份
    stackChart1_chgYear( year=1996 ){
        console.log('[stackChart1_chgYear]', year);
        this.pieYear = year;
        this.casdepart1 = [{name: "OA:", value: this.casdepart1_all[ this.pieYear ][0] },{name: "OD: ", value: this.casdepart1_all[ this.pieYear ][1] },{name: "OP: ", value: this.casdepart1_all[ this.pieYear ][2] }];
        this.casdepart2 = [{name: "OA:", value: this.casdepart2_all[ this.pieYear ][0] },{name: "OD: ", value: this.casdepart2_all[ this.pieYear ][1] },{name: "OP: ", value: this.casdepart2_all[ this.pieYear ][2] }];
        this.casdepart3 = [{name: "OA:", value: this.casdepart3_all[ this.pieYear ][0] },{name: "OD: ", value: this.casdepart3_all[ this.pieYear ][1] },{name: "OP: ", value: this.casdepart3_all[ this.pieYear ][2] }];
        this.casdepart4 = [{name: "OA:", value: this.casdepart4_all[ this.pieYear ][0] },{name: "OD: ", value: this.casdepart4_all[ this.pieYear ][1] },{name: "OP: ", value: this.casdepart4_all[ this.pieYear ][2] }];
        this.$forceUpdate();
    },


  }
}
</script>

<style lang="less">
/*.center{width:676px!important;}*/
/*.left,.right{width:50%!important;}*/



body{
  font-size:14px;
  background: #F8F8F8;
}


.cus-table{
  width:100%;
  border-collapse:collapse;
  thead{
    height:30px;
    line-height:30px;
    border-bottom:1px solid rgba(65, 69, 74,.1);
  }
  th{
    font-size: 16px;
    font-weight: bold;
    color: #007AFF;
  }
  tbody td{
    height:36px;
    line-height:36px;
  }
  tbody tr:nth-child(2n){
    background: rgba(0, 122, 255, 0.09);
    border-radius: 16px;
  }
  td{
    font-size: 16px;
    font-weight: bold;
    color: #7C7D7E;
    line-height: 44px;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width:1346px;
  margin:0 auto;
}
// .head_title{
//   font-size:14px;
//   background: '@/assets/images/title.png';
// }
.title-wraphead{
   margin: auto;
  // display: flex;

  background:url(~@/assets/images2/titlenew.png) no-repeat; background-size: 100%
}
.imgauto{
    width: auto;
    height: auto;
    max-width: 56px;
    max-height: 65px;
    margin-bottom: -10px;
    margin-left: -100px;
}
.imgback{
    width: auto;
    height: auto;
    margin-bottom: -2px;
}
.kctitleback{
   float:left;
   margin-top:10px;
   margin-left:20px;
   font-size: 0.5rem;
   font-weight: bold;
   color: #0361c7;
}
.kctitlefont{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.3rem;
    font-weight: bold;
    color: #0361c7;
    line-height: 70px;
}
.wrap{
  display: flex;
  .left{
    padding:10px 20px;
    box-sizing: border-box;
    // flex:1;
    width:25%;
  }
  .center{
    padding:10px 0;
    box-sizing: border-box;
    // flex:2;
    //width:50%;
    width:100%;         // 3列改1列
    .item-wrap {
      .experimentalCity {
        position: absolute;
        top: 90px;
        left: -10px;
        z-index: 99;
      }
    }
  }
  .right{
    padding:10px 20px;
    box-sizing: border-box;
    // flex:1;
    width:25%;
  }
  .item-wrap{
    position:relative;
    //margin-bottom:10px;
    margin-bottom:20px;
    border-radius: 10px;
    background:#fff;
    box-shadow: 0 0 5px 1px #c1ebfa;
  }

  .item-title{
    display: flex;
    padding:10px;
    line-height: 30px;
    justify-content: space-between;
    align-items: center;
    .item-title_name{
      display: flex;
      font-size: 20px;
      font-weight: bold;
      color: #666;
      align-items: center;
    }
    .title_icon{
      margin-right:10px;
      width:22px;
      height:20px;
    }
    .largen_icon{
      width:22px;
      height:23px;
      background:url(~@/assets/images/largen.png) no-repeat;
      background-size: cover;
      cursor: pointer;
    }
  }
  .more-table{
    position: absolute;
    right:60px;
    cursor: pointer;
  }
}
.child1-wrap{
  display: flex;
  .pie1-wrap{
    position: relative;
  }
  .pie1-img{
    position: absolute;
    margin-top:-15px;
    top:50%;
    left:50%;
    width:50px;
    height:50px;
    transform: translate(-50%,-50%);
  }
  .pie-info{
    display:flex;
    padding:0 4px;
    line-height:30px;
    justify-content:space-between;
    font-size:16px;
  }
}
.mask{
  position: fixed;
  z-index:10;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background:rgba(0,0,0,.6);
  overflow: auto;
}
.largen-wrap{
  position: absolute;
  left:50%;
  top:60px;
  transform: translateX(-50%);
  width:1346px;
  background:#fff;
  box-shadow: 0 0 10px 2px rgba(255,255,255,.6);
  border-radius: 10px;
  &.full-screen{
    left:0;
    top:0;
    width:100%;
    transform: translateX(0);
    border-radius: 0;
  }
}
.largen-content{
  max-height:calc(100vh - 160px);
  overflow:auto;
  &.full-screen{
    max-height:calc(100vh - 40px);
  }
}
.button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 8px 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #000;
}
.button--default {
    color: #606266;
}
.button--default:focus,.button--default:hover{
    color: #3a8ee6;
    border-color: #3a8ee6;
    outline: none;
}

.button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff
}

.button--primary:focus,.button--primary:hover {
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff
}
.hreflink{
  color: #333;
  text-decoration: none;
}

</style>

<style>
#app{ min-width: 1346px; }

/* 分辨率适配。要结合 isMobile() */

/* 宽度大于1900。用1920分辨率的效果 */
/* @media screen and (min-width: 1900px) { */
@media (min-width: 1600px) {
    .center{ width:950px; }
    .pie1-wrap{ height:446px!important; }           /* 468-30+8 */
}
/* 宽度小于或等于1899。用1366分辨率的效果 */
@media (min-width:694.4px) and (max-width:1599.98px) {
    .center{ width: 676px;}
    .pie1-wrap{ height:311px!important; }           /* 333-30+8 */
    .wrap .item-title .item-title_name{ font-size:14px; }
}


/* 宽度小于或等于694。嵌入iframe中, 且父页面认为是手机。3列变1列 */
/*@media (max-width:694.38px) {*/
@media (max-width:942.4px) {
    /* #app{ min-width: 700px; }       // 676+17=693 */

    #app.appMobile{ min-width: 700px; }

    .appMobile>>> table.table1{ height:auto!important; }

    .appMobile .center{ width: 676px; margin: 0 auto; }
    .appMobile .left, .appMobile .right{ width: 676px!important; margin:0 auto; padding-left:0!important; padding-right:0!important;  }
    .appMobile .wrap { display: block; }

}

</style>

